type ActivationSecurityPanelProps = {
  title: string
  items: string[]
}

export const ActivationSecurityPanel = ({ title, items }: ActivationSecurityPanelProps) => (
  <div className="max-w-[62ch] rounded-xl border border-[color-mix(in_srgb,var(--color-border-default)_76%,transparent)] bg-[color-mix(in_srgb,var(--color-bg-page-secondary)_56%,var(--color-bg-card))] p-3">
    <h3 className="text-xs font-semibold uppercase tracking-[0.11em] text-(--color-text-secondary)">{title}</h3>
    <ul className="mt-2 divide-y divide-[color-mix(in_srgb,var(--color-border-default)_60%,transparent)]">
      {items.map((item) => (
        <li key={item} className="flex items-center gap-2.5 py-2 text-xs text-(--color-text-secondary)">
          <span className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border border-[color-mix(in_srgb,var(--color-status-success)_28%,transparent)] bg-[color-mix(in_srgb,var(--color-status-success)_12%,transparent)] text-(--color-status-success)">
            <svg viewBox="0 0 20 20" className="h-3 w-3 fill-none stroke-current stroke-[2.2]" aria-hidden>
              <path d="m4.5 10.4 3.3 3.3 7.2-7.2" />
            </svg>
          </span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  </div>
)
